__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@hs-baumappe/bonus-calculation-web";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.13.5", () => (Promise.all([__webpack_require__.e(334), __webpack_require__.e(914), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(8334))))));
			register("@hs-baumappe/design-tokens", "6.0.0", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(178))))));
			register("@hs-baumappe/graphql-errors", "1.4.0", () => (Promise.all([__webpack_require__.e(834), __webpack_require__.e(212), __webpack_require__.e(171)]).then(() => (() => (__webpack_require__(3834))))));
			register("@hs-baumappe/redkit", "2.0.1", () => (Promise.all([__webpack_require__.e(148), __webpack_require__.e(21), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(171), __webpack_require__.e(549), __webpack_require__.e(23)]).then(() => (() => (__webpack_require__(6021))))));
			register("@hs-baumappe/snackbar-manager", "2.0.0", () => (Promise.all([__webpack_require__.e(148), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(417)]).then(() => (() => (__webpack_require__(9417))))));
			register("@hs-baumappe/web-auth", "4.4.0", () => (Promise.all([__webpack_require__.e(39), __webpack_require__.e(914), __webpack_require__.e(212), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(39))))));
			register("@react-pdf/renderer", "4.3.0", () => (Promise.all([__webpack_require__.e(682), __webpack_require__.e(914), __webpack_require__.e(404)]).then(() => (() => (__webpack_require__(7682))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(139).then(() => (() => (__webpack_require__(8139))))));
			register("date-fns", "4.1.0", () => (Promise.all([__webpack_require__.e(837), __webpack_require__.e(917)]).then(() => (() => (__webpack_require__(5837))))));
			register("graphql", "16.10.0", () => (__webpack_require__.e(989).then(() => (() => (__webpack_require__(8989))))));
			register("i18next", "24.2.3", () => (__webpack_require__.e(978).then(() => (() => (__webpack_require__(4978))))));
			register("launchdarkly-react-client-sdk", "3.9.0", () => (Promise.all([__webpack_require__.e(142), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(1142))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-i18next", "15.4.1", () => (Promise.all([__webpack_require__.e(117), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(4117))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(245), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(5626))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};